import { takeEvery, call, put } from "redux-saga/effects";
import {
  TRIGGER_PLAYWRIGHT_REGRESSION_REQUEST,
  TRIGGER_PLAYWRIGHT_REGRESSION_SUCCESS,
  TRIGGER_PLAYWRIGHT_REGRESSION_FAILURE,
} from "../actions/playwrightRegressionActions";
import { triggerPlaywrightRegressionApi } from "../apis/playwrightRegressionApi";

function* triggerPlaywrightRegression(action) {
  try {
    const result = yield call(triggerPlaywrightRegressionApi, action.payload);
    yield put({ type: TRIGGER_PLAYWRIGHT_REGRESSION_SUCCESS, payload: result });
  } catch (error) {
    yield put({
      type: TRIGGER_PLAYWRIGHT_REGRESSION_FAILURE,
      error: error.message,
    });
  }
}

export default function* playwrightRegressionSaga() {
  yield takeEvery(
    TRIGGER_PLAYWRIGHT_REGRESSION_REQUEST,
    triggerPlaywrightRegression,
  );
}
